import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import { useAuth } from 'app/context/auth-context'
import { useAppContext } from 'app/context/app-context';
import { Roles } from 'app/types';
import { QueueUserService } from 'app/services/QueueUserService';
import { InterviewSessionService } from 'app/services/InterviewSessionService';
import { EndReason, VideoSessionStatus } from 'app/API';

export function Logout() {
  const { user, logout } = useAuth();
  const { jobFair } = useAppContext();
  const [redirectPath, setRedirectPath] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const performLogout = async () => {
      if (!user) return;

      const isApplicant = user.roles?.includes(Roles.Applicant);

      // Leave queue if applicant (don't await if not critical)
      if (jobFair?.id && isApplicant) {
        await new QueueUserService().leaveQueueFromAllBooths(jobFair.id, user.id);
      }

      const isRecruiter = user.roles?.includes(Roles.Recruiter);

       if (jobFair?.id && isRecruiter) {
        const iSessions = await new InterviewSessionService().getActiveInterviewsByRecruiter(jobFair.id, user.id);
        if(iSessions?.length > 0 && iSessions[0].status === VideoSessionStatus.IN_PROGRESS){
                await new QueueUserService().endInterview(jobFair.id, iSessions[0].boothId, iSessions[0].id, user.id, EndReason.RecCLosedBrowser);
        }
      }
      if (isMounted && jobFair) {
        // Set redirect path based on role
        setRedirectPath(
          isApplicant ? `/join/${jobFair.alias}` : '/auth/login'
        );
      }

      // Perform logout
      await logout(user.organizationId, user.id, jobFair?.id);

      window.location.reload();

    };

    performLogout();

    return () => {
      isMounted = false;
    };
  }, []); // Empty dependency array - only run once on mount

  if (redirectPath) {
    return <Redirect to={redirectPath} />;
  }

  return null;
}
